export class PrescriptionSolution {
    public idPrescriptionSolution: number;
    public idPrescription: number;
    public idUsage: number;
    public idAdministrationType: number;
    public administrationType: string;
    public quantity: number;
    public idPresentation: number;
    public presentation: string;
    public idFrequency: number;
    public idTreatmentPeriod: number;
    public observation: string;
    public datetimeInclusion: Date;
    public idDilution: number;
    public dilution: string;
    public idMeasurementUnit: number;
    public nonDispensationReason: string;
    public nonDispensationIdUser: number;
    public idLookupAdministrationLocation: number;
    //public medicalPrescriptionReportName: string;
    public justification: string;
    public datetimeNonDispensation: Date;
    public idSubFrequency: number;
    public idDilutionUnit: number;
    public dilutionQuantity: string;
    public idUserRelease: number;
    public datetimeRelease: Date;
}